"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedOutputOption = exports.getOutputTypeDetails = void 0;
const OutputTypeLibrary = {
    MATBOARD_WALL_MAP: {
        name: "Matboard Wall Map",
        description: "stickers for a 3-layer mat board photo map",
        stickerName: "Sticker",
        stickersName: "Stickers",
        lineItemName: "Custom Photo Map Sticker",
        lineItemNamePlural: "Custom Photo Map Stickers",
    },
    MATBOARD_WALL_MAP_SINGLE: {
        name: "Matboard Wall Map",
        description: "a sticker for a 3-layer mat board photo map",
        stickerName: "Sticker",
        stickersName: "Stickers",
        lineItemName: "Custom Photo Map Sticker",
        lineItemNamePlural: "Custom Photo Map Stickers",
    },
    VEHICLE_MAP: {
        name: "RV Photo Map",
        description: "weatherproof stickers for a photo map which sticks to a vehicle",
        stickerName: "RV Sticker",
        stickersName: "RV Stickers",
        lineItemName: "Sticker for an RV Photo Map",
        lineItemNamePlural: "Stickers for an RV Photo Map",
    },
    VINYL_WALL_MAP: {
        name: "Wall Hanging Photo Map",
        description: "indoor stickers for a photo map which hangs on the wall",
        stickerName: "Wall Map Sticker",
        stickersName: "Wall Map Stickers",
        lineItemName: "Sticker for a Wall Hanging Photo Map",
        lineItemNamePlural: "Stickers for a Wall Hanging Photo Map",
    },
};
function getOutputTypeDetails(type) {
    if (!type) {
        return undefined;
    }
    return Object.assign({ type }, OutputTypeLibrary[type]);
}
exports.getOutputTypeDetails = getOutputTypeDetails;
function getSelectedOutputOption(type, scale, outputOptions) {
    if (!outputOptions) {
        return undefined;
    }
    return outputOptions.find(option => option.type === type && option.scale === scale);
}
exports.getSelectedOutputOption = getSelectedOutputOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3V0cHV0VHlwZUxpYnJhcnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9wcm9qZWN0L3NoYXJlZC9PdXRwdXRUeXBlTGlicmFyeS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBYUEsTUFBTSxpQkFBaUIsR0FHbkI7SUFDRixpQkFBaUIsRUFBRTtRQUNqQixJQUFJLEVBQUUsbUJBQW1CO1FBQ3pCLFdBQVcsRUFBRSw0Q0FBNEM7UUFDekQsV0FBVyxFQUFFLFNBQVM7UUFDdEIsWUFBWSxFQUFFLFVBQVU7UUFDeEIsWUFBWSxFQUFFLDBCQUEwQjtRQUN4QyxrQkFBa0IsRUFBRSwyQkFBMkI7S0FDaEQ7SUFDRCx3QkFBd0IsRUFBRTtRQUN4QixJQUFJLEVBQUUsbUJBQW1CO1FBQ3pCLFdBQVcsRUFBRSw2Q0FBNkM7UUFDMUQsV0FBVyxFQUFFLFNBQVM7UUFDdEIsWUFBWSxFQUFFLFVBQVU7UUFDeEIsWUFBWSxFQUFFLDBCQUEwQjtRQUN4QyxrQkFBa0IsRUFBRSwyQkFBMkI7S0FDaEQ7SUFDRCxXQUFXLEVBQUU7UUFDWCxJQUFJLEVBQUUsY0FBYztRQUNwQixXQUFXLEVBQ1QsaUVBQWlFO1FBQ25FLFdBQVcsRUFBRSxZQUFZO1FBQ3pCLFlBQVksRUFBRSxhQUFhO1FBQzNCLFlBQVksRUFBRSw2QkFBNkI7UUFDM0Msa0JBQWtCLEVBQUUsOEJBQThCO0tBQ25EO0lBQ0QsY0FBYyxFQUFFO1FBQ2QsSUFBSSxFQUFFLHdCQUF3QjtRQUM5QixXQUFXLEVBQUUseURBQXlEO1FBQ3RFLFdBQVcsRUFBRSxrQkFBa0I7UUFDL0IsWUFBWSxFQUFFLG1CQUFtQjtRQUNqQyxZQUFZLEVBQUUsc0NBQXNDO1FBQ3BELGtCQUFrQixFQUFFLHVDQUF1QztLQUM1RDtDQUNGLENBQUM7QUFFRixTQUFnQixvQkFBb0IsQ0FBQyxJQUF1QjtJQUMxRCxJQUFJLENBQUMsSUFBSSxFQUFFO1FBQ1QsT0FBTyxTQUFTLENBQUM7S0FDbEI7SUFDRCx1QkFDRSxJQUFJLElBQ0QsaUJBQWlCLENBQUMsSUFBSSxDQUFDLEVBQzFCO0FBQ0osQ0FBQztBQVJELG9EQVFDO0FBRUQsU0FBZ0IsdUJBQXVCLENBRXJDLElBQXVCLEVBQUUsS0FBYSxFQUFFLGFBQWtCO0lBQzFELElBQUksQ0FBQyxhQUFhLEVBQUU7UUFDbEIsT0FBTyxTQUFTLENBQUM7S0FDbEI7SUFDRCxPQUFPLGFBQWEsQ0FBQyxJQUFJLENBQ3ZCLE1BQU0sQ0FBQyxFQUFFLENBQUMsTUFBTSxDQUFDLElBQUksS0FBSyxJQUFJLElBQUksTUFBTSxDQUFDLEtBQUssS0FBSyxLQUFLLENBQ3pELENBQUM7QUFDSixDQUFDO0FBVEQsMERBU0MifQ==